const setDocumentTitle = (title: string): void => {
  document.title = `${title} - OGL Profit4`;
};

export default setDocumentTitle;
